import { requestWithHeaders } from '../helpers/request';
import * as settings from './settings';
import messages from './messages';
import { dispatchCustomEventDetail } from '../helpers/customEvent';
import { setCookie, deleteCookie } from '../helpers/cookies';
import { ADVISOR_LOGIN_LOADED } from '../helpers/constants';
import injectMcpSdk from '../components/Mcp';
import injectDynaTrace from '../components/DynaTrace';
import gtmEventPushAdvisorLogin from '../helpers/gtmEventPushAdvisorLogin';
import gtmEventPageView from '../helpers/gtmEventPageView';

const redirect = (timer) => {
  setTimeout(() => {
    if (window.xpSession)
      window.xpSession.logout;
    else
      window.location.reload(true);
  }, timer);
};


export const isAdvisorExpired = (xhr) => {
  if (xhr.status === 401) {
    redirect(1);
  } else if (xhr.status === 403) {
    messages.render('Sessao expirada');
  }

  window.localStorage.clear();
  window.sessionStorage.clear();
};

const setAdvisorWindow = (advisor) => {
  if (advisor) {
    if (!(window && window.advisorLogin)) {
      window.advisorLogin = advisor;
      dispatchCustomEventDetail(ADVISOR_LOGIN_LOADED, advisor);
    }
  }
};

const getIsPreAdvisor = (user) => {
  return requestWithHeaders({
    url: `${settings.api_advisor}/advisors/pre`,
    headers: {
      auth: `Bearer ${user.access_token}`,
      ocp: settings.ocp_apim,
    }
  });
};

const getUniversityUrl = (user) => {
  return requestWithHeaders({
    url: `${settings.api_advisor}/advisors/university/url`,
    headers: {
      auth: `Bearer ${user.access_token}`,
      ocp: settings.ocp_apim,
    }
  });
};

const getAdvisorLogin = (user) => {
  return requestWithHeaders({
    url: `${settings.api_advisor}/advisors`,
    headers: {
      auth: `Bearer ${user.access_token}`,
      ocp: settings.ocp_apim,
    }
  });
};

const getPermissions = (user) => {
  return new Promise((resolve, reject) => {
    requestWithHeaders({
      url: `${settings.api_hub_menu}/permissions`,
      headers: {
        auth: `Bearer ${user.access_token}`,
        ocp: settings.ocp_apim,
      }
    }).then((data) => {
      const advisorProfiles = JSON.parse(data).output;

      if (!sessionStorage.getItem('advisorProfiles')) {
        sessionStorage.setItem('advisorProfiles', JSON.stringify(advisorProfiles));
      }

      resolve();
    }).catch((error) => {
      sessionStorage.removeItem('advisorProfiles');
      reject(error);
    });
  });
};

const getRoute = () => {
  const route = window.location.pathname.split('/');

  if (route[1] === 'new') {
    return route[2];
  }

  return window.location.pathname.split('/')[1];
};

const verifyIfHasPermission = () => {
  const route = getRoute();
  const advisorProfiles = JSON.parse(sessionStorage.getItem('advisorProfiles'));
  const { profiles } = advisorProfiles;
  let hasPermission = false;
  let hasPermissionDashboard = false;

  if (profiles.length === 0) {
    window.location.href = '/rede/#/unauthorized';
  } else {
    profiles.forEach(profile => {
      if (route.replace(/\//g, '') === profile.access.replace(/\//g, '')) {
        hasPermission = true;
      }
      if (profile.access.replace(/\//g, '') === 'rede'.replace(/\//g, '')) {
        hasPermissionDashboard = true;
      }
    });
    if (!hasPermission && !hasPermissionDashboard) {
      // TODO: remover após migração Cloud to Cloud e projetos legados para Arsenal
      window.location.href = window.location.origin + (window.location.pathname.includes('new') ? '/new' + profiles[0].access : profiles[0].access);
    } else if (!hasPermission && hasPermissionDashboard) {
      // TODO: remover após migração Cloud to Cloud e projetos legados para Arsenal
      window.location.href = window.location.pathname.includes('new') ? '/new/rede' : '/rede';
    }
  }
};

const fetchTokenMelver = async (user) => {
  try {
    const data = await requestWithHeaders({
      url: `${settings.api_advisor}/advisors/university/url`,
      headers: {
        auth: `Bearer ${user.access_token}`,
        ocp: settings.ocp_apim,
      }
    });
    const parsedData = JSON.parse(data);
    const urlMelver = new URL(parsedData);
    const token = urlMelver.searchParams.get("token");
    return token;
  } catch (error) {
    throw error;
  }
}

const observerRoute = () => {
  verifyIfHasPermission();

  window.onpopstate = () => {
    verifyIfHasPermission();
  }
};

const getAdvisorPermissions = (user) => {
  getPermissions(user).then(() => {
    observerRoute();
  }).catch((error) => {
    console.log(error);
  });
};

const getCustomerDataAndSetCookie = async (user, advisor) => {
  const advisorCode = advisor.code;

  try {
    await requestWithHeaders({
      url: `${settings.api_hub_menu}/advisor-beta/${advisorCode}`,
      headers: {
        auth: `Bearer ${user.access_token}`,
        ocp: settings.ocp_apim,
      }
    });

    setCookie('customerData', { isBetaUser: true });
  } catch (error) {
    console.log('Esse assessor não faz parte do beta', error);
    deleteCookie('customerData', { isBetaUser: true });
  }
};

const isBlockAdvisor = async (advisor, user) => {
  if (advisor.profiles && advisor.profiles.length > 0 && advisor.profiles.includes('block_assessor')){
  try {
    let url_universidade_xp = settings.melver_redirect_course_path;
    try {
      const token = await fetchTokenMelver(user, window.xpSession.user.profile.account);
      url_universidade_xp += token
    } catch (error) {
      console.log(error);
    }
    finally {
      redirect(30000);
      messages.render('Bloqueio treinamento', window.xpSession.user.profile.name, url_universidade_xp, settings.melver_email_standardzation);
    }
  } catch (error) {
    console.log(error)
  }}
};

const fetchAdvisor = (user) => {
  getAdvisorLogin(user)
    .then((data) => {
      const advisor = JSON.parse(data).advisor;

      if (advisor) {
        setAdvisorWindow(advisor);
        getCustomerDataAndSetCookie(user, advisor);
        injectDynaTrace();
        injectMcpSdk();
        gtmEventPushAdvisorLogin(advisor);
        isBlockAdvisor(advisor, user);
      } else {
        redirect(30000);
        messages.render('Sem permissão');
      }
    })
    .catch((error) => {
      if (error.status === 401) {
        window.localStorage.clear();
        window.sessionStorage.clear();
        redirect(1);
      } else {
        redirect(30000);
        messages.render('Usuário indisponível');
      }
    });
};

const isPreAdvisor = async (user) => {
  try {
    let pre_advisor = await getIsPreAdvisor(user);
    pre_advisor = JSON.parse(pre_advisor);

    if (pre_advisor === null) {
      redirect(30000);
      return messages.render('Não encontrado');
    }

    if (pre_advisor) {
      let url_universidade_xp = settings.melver_redirect_course_path;
      try {
        const token = await fetchTokenMelver(user, window.xpSession.user.profile.account);
        url_universidade_xp += token
      } catch (error) {
        console.log(error);
      }
      finally {
        messages.render('Pre assessor', window.xpSession.user.profile.name, url_universidade_xp, settings.melver_email_standardzation);
      }
    } else {
      fetchAdvisor(user);
    }
  } catch (error) {
    fetchAdvisor(user);
  }
};

export const initAdvisors = (user) => {
  isPreAdvisor(user);
  getAdvisorPermissions(user);
};